module.exports = __webpack_public_path__ + "img/zxkt.4accf11c.png";